// Mock data for C² Productions Portfolio

export const mockData = {
  // Hero section data
  hero: {
    title: "C² Productions",
    subtitle: "Challenge & Capture",
    description: "Je conçois des sites web et boutiques e-commerce performantes, et je réalise des vidéos fortes pour valoriser votre activité. Deux expertises complémentaires, un seul interlocuteur.",
    backgroundVideo: "https://images.unsplash.com/photo-1552674605-db6ffd4facb5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxydW5uaW5nfGVufDB8fHx8MTc1NzkzNjY2MXww&ixlib=rb-4.1.0&q=85",
    logo: "/images/logo-dark.png",
    logoNav: "/images/logo-nav.png",
    logoMark: "/images/logo-mark.png",
    logoLight: "/images/logo.png",
    logoIcon: "/images/logo-icon.png",
    logoIconLight: "/images/logo-icon-light.png"
  },

  // About section data
  about: {
    title: "À propos",
    name: "Christopher Clercq",
    description: "Développeur web et vidéaste basé à Saint-Quentin. J'accompagne les entreprises et indépendants avec des sites rapides, des boutiques e-commerce efficaces et des vidéos qui racontent leur histoire.",
    story: "Installé à Saint-Quentin, je combine création digitale et production audiovisuelle pour répondre à vos objectifs business. Côté web, je conçois des interfaces claires, optimisées SEO et pensées pour convertir. Côté vidéo, je réalise des contenus dynamiques pour événements, entreprises et projets sportifs. J'interviens dans les Hauts-de-France et partout en France selon les besoins.",
    image: "/images/christopher.jpg",
    quote: "Des sites qui convertissent, des images qui marquent."
  },

  // Services data
  services: [
    {
      id: 1,
      title: "Site vitrine premium",
      description: "Un site clair, rapide et élégant pour présenter votre activité et convertir vos visiteurs.",
      image: "https://images.unsplash.com/photo-1545239351-1141bd82e8a6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw2fHxyZXNwb25zaXZlJTIwd2ViJTIwZGVzaWdufGVufDB8fHx8MTc1NzkzNzA5NXww&ixlib=rb-4.1.0&q=85",
      features: ["Design sur-mesure", "Responsive", "SEO de base", "Performance optimisée"],
      featured: true
    },
    {
      id: 2,
      title: "Boutique e-commerce",
      description: "Une boutique prête à vendre avec catalogue, paiements sécurisés et gestion des commandes.",
      image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw3fHxlY29tbWVyY2V8ZW58MHx8fHwxNzU3OTM3MDk1fDA&ixlib=rb-4.1.0&q=85",
      features: ["Parcours d'achat optimisé", "Paiements & livraison", "Gestion des produits", "Emails transactionnels"],
      featured: true
    },
    {
      id: 3,
      title: "Performance & SEO",
      description: "Optimisations techniques pour accélérer le site et améliorer la visibilité sur Google.",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw1fHxkYXRhJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc1NzkzNzA5NXww&ixlib=rb-4.1.0&q=85",
      features: ["Audit rapide", "Optimisation temps de chargement", "Structure SEO", "Tracking & analytics"],
      featured: true
    },
    {
      id: 4,
      title: "Maintenance & évolutions",
      description: "Mises à jour, sécurité, contenu et évolutions fonctionnelles selon vos besoins.",
      image: "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw5fHxkZXZlbG9wZXIlMjBjb2RlfGVufDB8fHx8MTc1NzkzNzA5NXww&ixlib=rb-4.1.0&q=85",
      features: ["Sécurité & sauvegardes", "Ajouts de pages", "Corrections rapides", "Support réactif"],
      featured: true
    }
  ],

  // Other services (less featured)
  otherServices: [
    {
      id: 5,
      title: "Événements Sportifs",
      description: "Couverture complète de courses, trails, triathlons et compétitions sportives.",
      image: "https://images.unsplash.com/photo-1571008887538-b36bb32f4571?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxydW5uaW5nfGVufDB8fHx8MTc1NzkzNjY2MXww&ixlib=rb-4.1.0&q=85",
      features: ["Captation multi-angles", "Highlights", "Livraison rapide", "Formats sociaux"]
    },
    {
      id: 6,
      title: "Vidéos d'Entreprise",
      description: "Présentation corporate, interviews et communication interne.",
      image: "https://images.unsplash.com/photo-1654723011680-0e037c2a4f18",
      features: ["Vidéos corporate", "Interviews", "Formations", "Événements pro"]
    },
    {
      id: 7,
      title: "Drone & FPV",
      description: "Prises de vues aériennes immersives et plans spectaculaires.",
      image: "https://images.unsplash.com/photo-1473968512647-3e447244af8f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxkcm9uZXxlbnwwfHx8fDE3NTc5MzY2NjZ8MA&ixlib=rb-4.1.0&q=85",
      features: ["Télépilote certifié", "Prises aériennes", "FPV immersif", "Plans spectaculaires"]
    }
  ],

  // Portfolio data (real projects)
  portfolio: {
    categories: ["Tous", "Mariages", "Entreprises", "Drone & FPV", "Sport", "Réels / Shorts"],
    projects: [
      // Mariages
      {
        id: 1,
        title: "Cathy & Jérôme – Mariage chrétien",
        category: "Mariages", 
        description: "Film tourné à l'iPhone, capturant l'émotion et la sincérité de la journée.",
        thumbnail: `https://img.youtube.com/vi/R7UavnLyBdc/maxresdefault.jpg`,
        videoUrl: "https://www.youtube.com/watch?v=R7UavnLyBdc",
        youtubeId: "R7UavnLyBdc",
        date: "2024",
        featured: false,
        format: "horizontal"
      },
      {
        id: 2,
        title: "Marine & Alexis – Mariage catholique",
        category: "Mariages",
        description: "Captation complète du mariage, mettant en valeur les moments clés.",
        thumbnail: `https://img.youtube.com/vi/afHVSpRr0cM/maxresdefault.jpg`,
        videoUrl: "https://youtu.be/afHVSpRr0cM",
        youtubeId: "afHVSpRr0cM",
        date: "2024",
        featured: false,
        format: "horizontal"
      },
      // Entreprises
      {
        id: 3,
        title: "Pension de Bonavis – Présentation",
        category: "Entreprises",
        description: "Vidéo de présentation de la pension chiens & chats, ambiance familiale et chaleureuse.",
        thumbnail: `https://img.youtube.com/vi/yOpYqdpULV0/maxresdefault.jpg`,
        videoUrl: "https://youtu.be/yOpYqdpULV0",
        youtubeId: "yOpYqdpULV0",
        date: "2024",
        featured: false,
        format: "horizontal"
      },
      {
        id: 4,
        title: "Domaine de Bonavis – Élevage Golden Retrievers & Petits Lévriers Italiens",
        category: "Entreprises",
        description: "Vidéo institutionnelle montrant l'élevage et l'environnement.",
        thumbnail: `https://img.youtube.com/vi/IUcG9nQt9Kk/maxresdefault.jpg`,
        videoUrl: "https://youtu.be/IUcG9nQt9Kk",
        youtubeId: "IUcG9nQt9Kk",
        date: "2024",
        featured: false,
        format: "horizontal"
      },
      // Drone & FPV
      {
        id: 5,
        title: "La Rotonde – Site SNCF abandonné à Laon",
        category: "Drone & FPV",
        description: "Vidéo FPV immersive d'un lieu abandonné, démontrant les compétences en pilotage et captation dynamique.",
        thumbnail: `https://img.youtube.com/vi/qTiFCgn47YY/maxresdefault.jpg`,
        videoUrl: "https://youtu.be/qTiFCgn47YY",
        youtubeId: "qTiFCgn47YY",
        date: "2024",
        featured: true,
        format: "horizontal"
      },
      // Sport (placeholder)
      {
        id: 6,
        title: "Projets sportifs à venir",
        category: "Sport",
        description: "Section dédiée aux futures vidéos de triathlon, trail, courses et événements sportifs.",
        thumbnail: "https://images.unsplash.com/photo-1571008887538-b36bb32f4571?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxydW5uaW5nfGVufDB8fHx8MTc1NzkzNjY2MXww&ixlib=rb-4.1.0&q=85",
        videoUrl: null,
        youtubeId: null,
        date: "À venir",
        featured: true,
        format: "horizontal",
        placeholder: true
      }
    ],
    
    // Section Réels / Shorts (contenu vertical)
    reels: [
      {
        id: "reel-1",
        title: "Adoption de lapins",
        description: "Réel pour promouvoir un service d'aide à l'adoption de lapins, sensibilisation et mise en avant du projet.",
        thumbnail: `https://img.youtube.com/vi/J5ONvzYcvDA/maxresdefault.jpg`,
        videoUrl: "https://youtube.com/shorts/J5ONvzYcvDA",
        youtubeId: "J5ONvzYcvDA",
        category: "Réels / Shorts",
        format: "vertical",
        placeholder: false
      },
      {
        id: "reel-2",
        title: "Running / Moi-même",
        description: "Réel personnel montrant ma course avec transitions créatives et dynamiques pour capturer l'énergie et le mouvement.",
        thumbnail: `https://img.youtube.com/vi/BhWU8U44snM/maxresdefault.jpg`,
        videoUrl: "https://youtube.com/shorts/BhWU8U44snM",
        youtubeId: "BhWU8U44snM",
        category: "Réels / Shorts",
        format: "vertical",
        placeholder: false
      },
      {
        id: "reel-3",
        title: "Pension de Bonavis – Promotion",
        description: "Réel promotionnel pour la pension de Bonavis, mettant en valeur les installations et l'accueil chaleureux.",
        thumbnail: `https://img.youtube.com/vi/tJz06RaUaDQ/maxresdefault.jpg`,
        videoUrl: "https://youtube.com/shorts/tJz06RaUaDQ",
        youtubeId: "tJz06RaUaDQ",
        category: "Réels / Shorts",
        format: "vertical",
        placeholder: false
      },
      {
        id: "reel-4",
        title: "Journée shooting photo mariage",
        description: "Réel long documentant une journée complète de shooting photo d'inspiration mariage, montrant le workflow et les préparatifs.",
        thumbnail: `https://img.youtube.com/vi/IAajzk7_TLo/maxresdefault.jpg`,
        videoUrl: "https://youtube.com/shorts/IAajzk7_TLo",
        youtubeId: "IAajzk7_TLo",
        category: "Réels / Shorts",
        format: "vertical",
        placeholder: false
      }
    ]
  },

  // Contact data
  contact: {
    title: "Contact",
    subtitle: "Parlez-moi de votre projet web ou vidéo",
    email: "christopher.clercq@gmail.com",
    social: {
      instagram: "https://www.instagram.com/c_squared.productions/"
    }
  },

  // Testimonials (optional for now)
  testimonials: [
    {
      id: 1,
      name: "Marie Dupont",
      role: "Organisatrice Marathon Local",
      comment: "Christopher a su capturer l'essence de notre événement. Ses vidéos ont eu un impact énorme sur notre visibilité.",
      rating: 5
    },
    {
      id: 2,
      name: "Paul Martin",
      role: "Triathlète Professionnel",
      comment: "Une approche professionnelle et une compréhension parfaite du monde sportif. Je recommande vivement !",
      rating: 5
    }
  ]
};

export default mockData;
